import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 20 20"
        ref={ref}
        {...props}
    >
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M8.34 6.694a1.807 1.807 0 0 0-2.484 0 1.599 1.599 0 0 0 0 2.326c.683.659 1.8.659 2.483 0a1.599 1.599 0 0 0 0-2.326ZM4.883 5.687a3.207 3.207 0 0 1 4.427 0 2.999 2.999 0 0 1 0 4.34 3.207 3.207 0 0 1-4.427 0 2.999 2.999 0 0 1 0-4.34Zm6.615 2.384a.7.7 0 0 1 .7-.7H17.3a.7.7 0 0 1 .7.7v2.143a.7.7 0 0 1-.7.7h-5.101a.7.7 0 0 1-.7-.7V8.071Zm1.4.7v.743H16.6v-.743h-3.701Zm-1.4 3.5a.7.7 0 0 1 .7-.7h3.518a.7.7 0 0 1 .7.7v2.143a.7.7 0 0 1-.7.7h-3.518a.7.7 0 0 1-.7-.7v-2.143Zm1.4.7v.743h2.118v-.743h-2.118Zm-8.245 0c-.716 0-1.254.555-1.254 1.186v.343a.7.7 0 1 1-1.4 0v-.343c0-1.451 1.212-2.586 2.654-2.586h4.887a.7.7 0 1 1 0 1.4H4.654Z"
            clipRule="evenodd"
        />
    </svg>
);
const ForwardRef = forwardRef(SvgComponent);
export default ForwardRef;
